import { Add, FilterAlt, LanguageRounded, LocationOn, TranslateRounded } from '@mui/icons-material'
import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import image from '../../../assets/Images/nofilter.png'
import useNoResultsFound from '../hooks/useNoResultsFound'
import useScreenWidth from '../hooks/useScreenWidth'

function NotFilter({ handleClearFilters = () => {} }: any) {
  const isMobile = useScreenWidth(700)
  const { t } = useTranslation(['global'])
  const { pathname } = useLocation()

  const { clearFilters, noResultsMsg, languageName, countryName } = useNoResultsFound(handleClearFilters)

  let isAdmin = pathname.includes('admin')
  return (
    <Container maxWidth={'md'} style={isAdmin ? { marginTop: 20 } : {}}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={8}>
          <Box mt={2} display="flex" gap={6}>
            <Typography variant="h6">{t('no-content.no-related-content')}</Typography>
          </Box>

          <Box display="flex" gap={8} alignItems="center" mb={2}>
            <Typography>{t('no-content.following-steps')}</Typography>
          </Box>
          <Box display="flex" width={isMobile ? '100%' : '86%'} justifyContent="center" alignItems="center" mb={2}>
            <Button color="primary" variant="contained" onClick={() => clearFilters()} size="medium">
              {t('no-content.clean-filters')}
            </Button>
          </Box>
          <Box
            sx={theme => ({
              display: 'flex',
              gap: '16px',
              paddingRight: '14%',
              margin: '24px 0px',
              alignItems: 'center',
              '& p': {
                whiteSpace: 'nowrap'
              },
              [theme.breakpoints.down('xs')]: {
                paddingRight: 0
              }
            })}
          >
            <Box
              sx={theme => ({
                height: 1,
                width: '100%',
                backgroundColor: theme.palette.grey[400]
              })}
            />
            <Typography>{isAdmin ? t('no-content.or-you-can') : t('no-content.or-you-can-change')}</Typography>
            <Box
              sx={theme => ({
                height: 1,
                width: '100%',
                backgroundColor: theme.palette.grey[400]
              })}
            />
          </Box>

          {isAdmin ? (
            <>
              <Box display="flex" gap={1} alignItems="center" mb={2}>
                <LanguageRounded color="secondary" />
                <Typography>{t('no-content.change-selected-countries')}</Typography>
              </Box>
              <Box display="flex" gap={1} alignItems="center" mb={2}>
                <Add color="secondary" />
                <Typography>{t('no-content.create-new-element')}</Typography>
              </Box>
            </>
          ) : (
            <>
              <Box display="flex" gap={1} alignItems="center" mb={2}>
                <TranslateRounded color="primary" />
                <Typography>{t('no-content.current-language')}</Typography>
                <Typography color="primary" style={{ fontWeight: 500 }}>
                  {languageName}
                </Typography>
              </Box>
              <Box display="flex" gap={1} alignItems="center" mb={2}>
                <LocationOn color="primary" />
                <Typography>{t('no-content.current-country')}</Typography>
                <Typography color="primary" style={{ fontWeight: 500 }}>
                  {countryName}
                </Typography>
              </Box>
            </>
          )}
          {noResultsMsg && (
            <Box display="flex" gap={1} alignItems="center" mb={2} mt={2}>
              <FilterAlt fontSize="small" color="primary" />
              <Typography variant="body2">{noResultsMsg}</Typography>
            </Box>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <Box my={4}>
            <img src={image} width="100%" alt="logonotfound" />
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default NotFilter
